/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type { Registre } from '@/types';

import validationInformationsActe from '../validationInformationsActe';
import validationInformationsEvenementMariage from '../validationInformationsEvenementMariage';

/**
 * Validation de l'étape « Acte » pour le mariage : informations de l'acte
 * (réutilisées telles quelles), célébration et contrat. Les conjoints et leurs
 * parents sont validés dans leurs propres étapes.
 *
 * Aucune collision de clés entre les blocs (`registre`/`sousTypeActe`/
 * `dateActe`/… vs `dateMariage`/`adresseMariage`/`dateContratMariage`).
 */
const validationStep1Mariage = (
  data: Record<string, any>,
  selectedRegistre?: Partial<Registre>,
) => ({
  ...validationInformationsActe(data, selectedRegistre),
  ...validationInformationsEvenementMariage(data),
});

export default validationStep1Mariage;
